import { useNavigate } from "react-router-dom";
import { useNotifications } from "../hooks/useNotifications";
import { useEffect } from "react";

interface ActivityNotificationButtonProps {
  clearmatchee: () => void;
}

const ActivityNotificationButton = ({
  clearmatchee,
}: ActivityNotificationButtonProps) => {
  const navigate = useNavigate();

  // Notification system
  const {
    hasUnreadNotifications,
    isConnected,
    initializeNotifications,
    markAsRead,
    cleanup,
  } = useNotifications();

  // Initialize notification system
  useEffect(() => {
    const rawHandle = localStorage.getItem("handle");
    const userHandle = rawHandle ? JSON.parse(rawHandle) : null;

    if (userHandle?.user?.id && userHandle?.token?.access_token) {
      // Initialize WebSocket connection for notifications
      initializeNotifications(
        userHandle.user.id,
        userHandle.token.access_token
      );

      // Cleanup function
      return () => {
        cleanup();
      };
    }
  }, [initializeNotifications, cleanup]);

  return (
    <div
      className="absolute bottom-5 left-1/2 -translate-x-1/2"
      onClick={() => {
        // Mark notifications as read when user clicks on activity
        if (hasUnreadNotifications) {
          markAsRead();
        }
        clearmatchee();
        navigate("/activity");
      }}
    >
      <img src="/icons/Sangati/notification.svg" alt="" />
      {/* Red dot indicator for unread notifications */}
      {hasUnreadNotifications && (
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-sangati-orange rounded-full border-2 border-white"></div>
      )}
      {/* Connection status indicator (only show when disconnected) */}
      {!isConnected && (
        <div
          className="absolute -top-1 -left-1 w-3 h-3 bg-yellow-500 rounded-full border-2 border-white animate-pulse"
          title="Reconnecting to notifications..."
        ></div>
      )}
    </div>
  );
};

export default ActivityNotificationButton;
